import {cn} from '@/lib/utils';
import {ReactNode} from 'react';

type Props = {
  children?: ReactNode;
};
export default function DefaultTemplate({children}: Props) {
  return (
    <div className={cn('md:flex ')}>
      <div className={cn('relative flex grow flex-col w-full')}>
        <div className="md:text-[18px] min-h-[calc(100vh-600px)] relative">
          {children}
        </div>
      </div>
    </div>
  );
}
